import { Link } from "react-router-dom";

const Navigation = ({ items }) => {
  return (
    <nav className="flex flex-wrap my-4 relative">
      {items.map((item) => (
        <Link
          className="flex-1 border border-r-0 p-3 last:border-r hover:bg-gray-50"
          key={item.id}
          to={item.url}
        >
          <div className="flex items-center justify-center">
            {item.icon}
            <span className="hidden text-gray-400 text-sm tracking-wider lg:block ml-4 uppercase">
              {item.title}
            </span>
          </div>
        </Link>
      ))}
    </nav>
  );
};

export default Navigation;
